import { FaBars } from 'react-icons/fa';
import { NavLink as Link } from 'react-router-dom';
import styled from 'styled-components';

export const Nav = styled.nav`
  background: rgb(48, 47, 47);
  height: 85px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  z-index: 12;
`;
export const NavLogo = styled(Link)`
  cursor: pointer;
  color: #fff;
  font-size: 2rem;
  text-decoration: none;
  margin-left: 150px;
`;

export const NavLink = styled(Link)`
  color: #fff;
  display: flex;
  align-items: center;
  text-decoration: none;
  padding-left: 1rem;
  height: 100%;
  cursor: pointer;
  &.active {
    color: rgba(208, 156, 33, 0.8);
  }
  &:hover {
    color: #bca008;
  }
`;

export const Bars = styled(FaBars)`
  display: none;
  color: #fff;
  // @media screen and (max-width: 812px) {
  //   display: block;
  //   position: absolute;
  //   top: 0;
  //   right: 0;
  //   transform: translate(-100%, 75%);
  //   font-size: 1rem;
  //   cursor: pointer;
  // }
`;

export const NavMenu = styled.div`
  display: flex;
  align-items: center;
 

  @media screen and (max-width: 812px) {
    // display: none;
    font-size:0.7rem
   
  }
`;

export const NavBtn = styled.nav`
  display: flex;
  align-items: center;
  margin-right: 24px

  @media screen and (max-width:812px) {
    display: none;
    font-size:0.5rem
  }
`;

export const NavBtnLink = styled(Link)`
  border-radius: 4px;
  background: transparent;
  padding: 10px 22px;
  color: #fff;
  outline: none;
  border: 1px solid #fff;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  text-decoration: none;
  margin-left: 12px;
  &:hover {
    transition: all 0.2s ease-in-out;
    background: #fff;
    color: #808080;
  }
`;
